"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateCloneAllocationMutation = exports.useConfirmCloneBatchRootingMutation = exports.useGetCloneBatchQuery = exports.useGetCloneBatchesQuery = exports.cloneBatchApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
var mother_plant_1 = require("./mother-plant");
var seed_1 = require("./seed");
exports.cloneBatchApi = (0, react_1.createApi)({
    reducerPath: "cloneBatchApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["cloneBatch"],
    endpoints: function (builder) { return ({
        getCloneBatches: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/clone-batch", function (arg) { return ({
                motherPlant_id: arg.motherPlantId,
            }); }),
            providesTags: ["cloneBatch"],
        }),
        getCloneBatch: builder.query({
            query: function (_a) {
                var id = _a.id;
                return "/v1/clone-batch/".concat(id);
            },
            providesTags: ["cloneBatch"],
        }),
        confirmCloneBatchRooting: builder.mutation({
            query: function (_a) {
                var id = _a.id, body = __rest(_a, ["id"]);
                return ({ url: "/v1/clone-batch/".concat(id, "/confirm-rooting"), method: "PATCH", body: body });
            },
            invalidatesTags: ["cloneBatch"],
        }),
        createCloneAllocation: builder.mutation({
            query: function (_a) {
                var id = _a.id, clientId = _a.clientId, body = __rest(_a, ["id", "clientId"]);
                return ({ url: "/v1/clone-batch/".concat(id, "/allocations"), method: "POST", body: __assign(__assign({}, body), { client_id: clientId }) });
            },
            invalidatesTags: ["cloneBatch"],
            // A NEW_MOTHER allocation adds a mother plant, a PRODUCTION one adds starting material, and every allocation moves the Mother Room figures.
            onQueryStarted: function (_argument_1, _a) {
                return __awaiter(this, arguments, void 0, function (_argument, _b) {
                    var _c;
                    var dispatch = _b.dispatch, queryFulfilled = _b.queryFulfilled;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                _d.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, queryFulfilled];
                            case 1:
                                _d.sent();
                                dispatch(mother_plant_1.motherPlantApi.util.invalidateTags(["motherPlant"]));
                                dispatch(seed_1.seedApi.util.invalidateTags(["seed"]));
                                return [3 /*break*/, 3];
                            case 2:
                                _c = _d.sent();
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        }),
    }); },
});
exports.useGetCloneBatchesQuery = exports.cloneBatchApi.useGetCloneBatchesQuery, exports.useGetCloneBatchQuery = exports.cloneBatchApi.useGetCloneBatchQuery, exports.useConfirmCloneBatchRootingMutation = exports.cloneBatchApi.useConfirmCloneBatchRootingMutation, exports.useCreateCloneAllocationMutation = exports.cloneBatchApi.useCreateCloneAllocationMutation;
